import { MANUAL_LANGUAGE_SELECTION } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';

const useHasAccessToManualLanguageSelection = (): boolean => {
  const hasManualLanguageSelectionCapability = useHasCapability(
    MANUAL_LANGUAGE_SELECTION,
  );

  return !!hasManualLanguageSelectionCapability?.hasCapability;
};

export default useHasAccessToManualLanguageSelection;
